<template>
  <generic-modal :title="$t('central dispatch contact')" ref="generic_modal">
    <div v-if="contact_loaded">
      <div class="contact-details box">
        <h3 class="title is-5 mb-3">
          <i class="fa fa-building mr-2"></i>{{ contact.companyName }}
        </h3>
        <div class="columns is-multiline">
          <div class="column is-half">
            <p>
              <strong
                ><i class="fa fa-envelope mr-1"></i>{{ $t("email") }}:</strong
              >
              <a :href="'mailto:' + contact.email">{{ contact.email }}</a>
            </p>
            <p>
              <strong
                ><i class="fa fa-users mr-1"></i>{{ $t("tier group") }}:</strong
              >
              {{ contact.tierGroup }}
            </p>
            <p>
              <strong
                ><i class="fa fa-id-badge mr-1"></i
                >{{ $t("customer id") }}:</strong
              >
              {{ contact.customerId }}
            </p>
            <p>
              <strong
                ><i class="fa fa-clock mr-1"></i
                >{{ $t("headquarters time zone") }}:</strong
              >
              {{ contact.hqTimeZone }}
            </p>
            <p>
              <strong
                ><i class="fa fa-calendar mr-1"></i
                >{{ $t("hours of operation") }}:</strong
              >
              {{ contact.hoursOfOperation }}
            </p>
          </div>
          <div class="column is-half">
            <p>
              <strong
                ><i class="fa fa-phone mr-1"></i>{{ $t("main phone") }}:</strong
              >
              <a :href="'tel:' + contact.phone">{{ contact.phone }}</a>
            </p>
            <p>
              <strong
                ><i class="fa fa-list mr-1"></i
                >{{ $t("phone numbers") }}:</strong
              >
            </p>
            <ul>
              <li
                v-for="phone in contact.phoneNumbers"
                :key="phone.phoneNumber"
                class="mb-1"
              >
                <span class="tag is-info mr-1">{{
                  $t(phone.type.toLowerCase())
                }}</span>
                <a :href="'tel:' + phone.phoneNumber">{{
                  phone.phoneNumber
                }}</a>
                <span v-if="phone.extension"
                  >({{ $t("ext") }}: {{ phone.extension }})</span
                >
              </li>
            </ul>
            <p class="mt-2">
              <strong
                ><i class="fa fa-star mr-1"></i
                >{{ $t("overall rating") }}:</strong
              >
              <span v-if="contact.overallRating.totalAmount > 0">
                <span class="has-text-warning">
                  <i class="fa fa-star"></i>
                  {{ contact.overallRating.averageRating }} / 5
                </span>
                ({{ contact.overallRating.totalAmount }} {{ $t("ratings") }})
              </span>
              <span v-else>{{ $t("no ratings yet") }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import {
  put,
  format_date,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "CentralDispatchServiceModal",
  components: { GenericModal },
  data() {
    return {
      contact: null,
      contact_loaded: false,
      error: "",
    };
  },
  computed: {},
  methods: {
    format_date,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show(service_uuid) {
      let v = this;
      v.set_initial_state();

      get("/central-dispatch-tracker/contact", { uuid: service_uuid })
        .then((element) => {
          v.contact = element;
          v.contact_loaded = true;
          v.error = "";
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$refs.generic_modal.show_modal();
        });
    },
    set_initial_state() {
      let v = this;
      v.contact = null;
      v.error = "";
      v.contact_loaded = false;
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style scoped>
.contact-details.box {
  border-radius: 8px;
  padding: 1.5rem;
  /* background: #f8fafc; */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.tag.is-info {
  background: #209cee;
  color: #fff;
  font-size: 0.9em;
}
.title.is-5 {
  display: flex;
  align-items: center;
}
.fa {
  margin-right: 0.3em;
}
</style>
